// apps/web/src/pages/jobs/JobsFeed.tsx

import React from 'react';
import { trpc } from '@/trpc/client';
import JobCard from '@/components/JobCard';
import { Skeleton } from '@/components/ui/skeleton';
import { FileQuestion } from 'lucide-react';
import { Link } from 'react-router-dom';
const JobCardSkeleton: React.FC = () => (
  <Skeleton className="w-full h-80 rounded-lg" />
);

const JobsFeed: React.FC = () => {
  // This must include `images` in your backend query:
  // prisma.job.findMany({ include: { images: true } })
  const { data: jobs, isLoading, isError, error } =
    trpc.job.getAll.useQuery();

  // 1) Loading state
  if (isLoading) {
    return (
      <div className="container mx-auto py-12 px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <JobCardSkeleton key={i} />
          ))}
        </div>
      </div>
    );
  }

  // 2) Error state
  if (isError) {
    return (
      <div className="container mx-auto py-12 px-4 text-center text-destructive">
        Failed to load jobs: {error?.message}
      </div>
    );
  }

  // 3) Empty state
  if (!jobs || jobs.length === 0) {
    return (
      <div className="container mx-auto py-12 px-4 text-center text-muted-foreground space-y-4">
        <FileQuestion className="w-16 h-16 mx-auto" />
        <h2 className="text-2xl font-semibold">No Active Jobs Found</h2>
        <p>Please check back later!</p>
      </div>
    );
  }

  // 4) Success: render each job with every image
  return (
    <div className="container mx-auto py-4 px-2 sm:py-12 sm:px-4 animate-fade-in space-y-6 sm:space-y-8">
      <div className="text-center space-y-2">
        <h1 className="text-2xl sm:text-4xl font-bold">Find Your Next Job</h1>
        <p className="text-muted-foreground text-sm sm:text-base">
          Browse the marketplace for available loads.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
        {jobs.map((job) => (
          <JobCard key={job.id} job={job} />
        ))}
      </div>
    </div>
  );
};

export default JobsFeed;
